<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'kkey'
        label= '关键词'
        width= '150'>
      </el-table-column>
      <el-table-column
        prop= 'val'
        label= '值'
        width= '150'>
      </el-table-column>
      <el-table-column
        prop= 'sort'
        label= '排序'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>
      <el-table-column
        prop= 'isSystem'
        label= '字典类型'
        width= '100'>
        <template slot-scope='scope'>
          <el-button type='primary' size='small' v-if="scope.row.isSystem===1">系统默认</el-button>
          <el-button type='success' size='small' v-if="scope.row.isSystem===0">普通字典</el-button>
        </template>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323" v-if="scope.row.isSystem===0">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c" v-if="scope.row.isSystem===0">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="关键词" :label-width="formLabelWidth">
          <el-input v-model="form.kkey" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="值" :label-width="formLabelWidth">
          <el-input v-model="form.val" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="form.sort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="字典类型" :label-width="formLabelWidth">
          <el-radio-group v-model="form.isSystem" size="medium">
            <el-radio-button label=1>系统默认</el-radio-button>
            <el-radio-button label=0>普通字典</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        kkey: null,
        val: null,
        descr: null,
        isSystem: 0,
        sort: 0
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 9,
      total: 0,
      pages: 0
    }
  },
  created () {
    this.query()
  },
  methods: {
    del (row) {
      let that = this
      console.log('del')
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/dict/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      console.log('delClose')
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/dict/listPage?current=${that.current}&pageSize=${that.pageSize}&name=${that.name}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    submitForm () {
      let that = this
      that.dialogFormVisible = false
      console.log('add')
      let url = '/dict/add'
      if (that.form.id) {
        url = '/dict/edit'
      }
      requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.query()
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/dict/Index.vue